import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Sort} from '@angular/material/sort';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {SharedService} from '../../../services/shared-service';
import {CaseDTO} from '../../../../clm/models/CaseDTO';
import {DateUtil} from '../../../util/DateUtil';
import {TableControl} from '../../../models/TableControl';
import {PagedFilterDTO} from '../../../models/PagedFilterDTO';
import {PagedResponseDTO} from '../../../models/PagedResponseDTO';
import {CaseService} from '../../../../clm/services/case.service';
import {ClmRequestBuilder} from '../../../../clm/services/clm-request-builder';
import {CaseStatus} from '../../../../clm/types';
import {MatTableDataSource} from '@angular/material/table';
import {detailsExpand} from '../../../animations';

enum TableColumns {
  CaseId = 'caseId',
  ProcessingClass = 'processingClass',
  Name = 'name',
  StartDate = 'startDate',
  InsuredPerson = 'insuredPerson',
  ElapsedDays = 'elapsedDays',
  CaseStatus = 'caseStatus',
  CaseManager = 'caseManager',
}

@Component({
  selector: 'app-cases-overview',
  templateUrl: './cases-overview.component.html',
  styleUrls: [
    '../../../../../../styles/global/_management-styles.scss',
    '../../../../../../styles/global/_dialog-styles.scss',
    './cases-overview.component.scss'
  ],
  animations: [detailsExpand]
})
export class CasesOverviewComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject();
  readonly dateFormat = DateUtil.dateFormat;
  readonly dateTimeFormat = DateUtil.dateTimeFormat;
  readonly caseStatus = CaseStatus;
  readonly controls = ClmRequestBuilder.getTableControls();
  readonly tableColumns = TableColumns;

  casesDataSource: MatTableDataSource<CaseDTO> = new MatTableDataSource();
  caseTableControl: TableControl;
  caseExpandedRow: CaseDTO | null;
  casesDisplayedColumns: string[] = Object.values(TableColumns);

  @ViewChild('casePaginator', {static: false}) casePaginator: MatPaginator;

  constructor(
    private caseService: CaseService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetails: BasicPersonDetailDTO) {
    this.caseTableControl = new TableControl(
      this.controls.length,
      this.controls.pageSize,
      this.controls.pageNumber,
      this.controls.pageSizeOptions,
      'caseId',
      'desc',
      'name',
      '');
  }


  get isDataExist(): boolean {
    return !!(this.casesDataSource && this.casesDataSource.data?.length);
  }

  ngOnInit(): void {
    this.getListOfCases(this.caseTableControl);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getListOfCases(tableControl: TableControl): void {
    const pagedRequestDTO = ClmRequestBuilder.getListOfCasesPagedRequestDTO(tableControl);
    pagedRequestDTO.fieldMap = {};

    const personPagedFilterDTO = new PagedFilterDTO();
    personPagedFilterDTO.name = 'insuredPersonByInsuredPersonId.insuredPersonId';
    personPagedFilterDTO.value = String(this.basicPersonDetails.personId);
    pagedRequestDTO.fieldMap[`insuredPersonByInsuredPersonId_1`] = personPagedFilterDTO;

    this.caseService.getListOfCases(pagedRequestDTO)
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (response: PagedResponseDTO<CaseDTO>) => {
          this.casesDataSource.data = response.resultList;
          this.caseTableControl.length = response.totalRecords;
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  sortData($event: Sort): void {
    if (!$event.direction) {
      return;
    }
    if (this.casePaginator) {
      this.casePaginator.firstPage();
    }
    this.caseTableControl.pageNumber = 0;

    if ($event.active === 'insuredPerson') {
      this.caseTableControl.sortField = 'insuredPersonByInsuredPersonId.lastName';
    }
    else if ($event.active === 'processingClass') {
      this.caseTableControl.sortField = 'processingClassByProcessingClassId.className';
    }
    else {
      this.caseTableControl.sortField = $event.active;
    }

    this.caseTableControl.sortDirection = $event.direction;
    this.getListOfCases(this.caseTableControl);
  }

  pageChanged($event: PageEvent): void {
    this.caseTableControl.pageNumber = $event.pageIndex;
    this.caseTableControl.pageSize = $event.pageSize;
    this.getListOfCases(this.caseTableControl);
  }
}
